export function readBrowserSafeEnv(key: string): string | undefined {
  if (typeof process === "undefined") return undefined;

  // Statically reference NEXT_PUBLIC_ and other client-accessible variables
  // so the Next.js compiler/bundler can correctly inline them on the client side.
  // Dynamic property lookups (like process.env[key]) return undefined in the browser.
  switch (key) {
    case "NEXT_PUBLIC_R2_PUBLIC_BASE_URL":
      return process.env.NEXT_PUBLIC_R2_PUBLIC_BASE_URL;
    case "NEXT_PUBLIC_GOOGLE_WEB_CLIENT_ID":
      return process.env.NEXT_PUBLIC_GOOGLE_WEB_CLIENT_ID;
    case "NEXT_PUBLIC_GOOGLE_IOS_CLIENT_ID":
      return process.env.NEXT_PUBLIC_GOOGLE_IOS_CLIENT_ID;
    case "NEXT_PUBLIC_HIIVE_RECORDING_AUTOSTART":
      return process.env.NEXT_PUBLIC_HIIVE_RECORDING_AUTOSTART;
    case "NEXT_PUBLIC_APP_URL":
      return process.env.NEXT_PUBLIC_APP_URL;
    case "NEXT_PUBLIC_VAPID_PUBLIC_KEY":
      return process.env.NEXT_PUBLIC_VAPID_PUBLIC_KEY;
    case "NODE_ENV":
      return process.env.NODE_ENV;
    default:
      return process.env[key];
  }
}

export function readBrowserSafeNodeEnv(): string | undefined {
  return readBrowserSafeEnv("NODE_ENV");
}
